module.exports = __webpack_public_path__ + "media/images/great-place-to-work-df3721974b92621bde24b7c5654fdbe3.png";